import { render, staticRenderFns } from "./MfaPage.vue?vue&type=template&id=181dd713&scoped=true"
import script from "./MfaPage.vue?vue&type=script&lang=js"
export * from "./MfaPage.vue?vue&type=script&lang=js"
import style0 from "./MfaPage.vue?vue&type=style&index=0&id=181dd713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181dd713",
  null
  
)

export default component.exports